import { MagicLink } from "../../../../core/ui";
import { CoastShowPayload } from "./CoastContent.types";

interface CoastContentShowBumperMusicProps {
    show: CoastShowPayload;
}

export const CoastContentShowBumperMusic = ({ show: { fields } }: CoastContentShowBumperMusicProps) => {
    return fields.bumper_music?.value?.length ? (
        <section className="bumper-music">
            <h3>Bumper Music:</h3>

            <ul>
                {fields.bumper_music.value.map((track, idx) => (
                    <li key={idx}>
                        <MagicLink external={true} target="_blank" to={track.url}>
                            {track.title}
                        </MagicLink>
                        <br />
                        <span>{track.artist}</span>
                    </li>
                ))}
            </ul>
        </section>
    ) : null;
};
